import { transformPhoneNumberToNormalizedForm } from "@daytrip/utils";
import { Exclude, Expose, Transform } from "class-transformer";
import { IsDate, IsDefined, IsEmail, IsString, IsUUID, Length } from "class-validator";

import { GField, GInputType, GObjectType } from "../graphql";

@GInputType("ContactInput")
@GObjectType("Contact")
@Exclude()
export class Contact {
    @GField({ nullable: true })
    @IsDate()
    @IsDefined()
    @Expose()
    @Transform((value) => (!value ? undefined : new Date(value)))
    public birthdayAt?: Date;

    @GField({ nullable: true })
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public countryId: string;

    @GField()
    @IsEmail()
    @Length(5, 48)
    @IsString()
    @IsDefined()
    @Expose()
    public email: string = "";

    @GField({ nullable: true })
    @Length(0, 48)
    @IsString()
    @IsDefined()
    @Expose()
    public firstName: string = "";

    @GField({ nullable: true })
    @Length(0, 48)
    @IsString()
    @IsDefined()
    @Expose()
    public lastName: string = "";

    @GField({ nullable: true })
    @Length(0, 18)
    @IsString()
    @IsDefined()
    @Transform((value) => transformPhoneNumberToNormalizedForm(value))
    @Expose()
    public phoneNumber: string = "";
}
